import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import { List, ListItem } from 'rmwc/List';
import { Checkbox } from 'rmwc/Checkbox';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'

class CoursePackageDetails extends Component {

  constructor(props){
    super(props);
    this.state={
      errorMsg: '',
      data: {
        purchaseModules: [],
      },
    }
  }

  componentDidMount() {

    let packageId = this.props.id
    let data = Object.assign({}, this.state.data)
    api.getPurchaseModules(this.props.user.accessToken, packageId)
      .then((result) => {
        if(result.status === 'success'){
          data.purchaseModules = result.data
          this.setState({data: data})
        }
        else {
          this.setState({errorMsg: 'Error in fetching the details, Please contact admin.'})
        }
      })
  }

  handleBack = (e) => {
    e.preventDefault();
    this.props.onBack()
  }

  render() {
    let purchaseModules = this.state.data.purchaseModules
    let packageName = this.props.packageName
    let displayComponent
    if(purchaseModules.length !== 0 || purchaseModules.length !== undefined){
      displayComponent = (
        <Grid>
          {purchaseModules.map(function(modules) {
            return(
              <GridCell span="12" key={modules.id}>{modules.name}</GridCell>
            )
          })}
        </Grid>      
      )
    }
    else {
      displayComponent = (
        <div>
          <Typography use="headline6">No Modules are available</Typography>
        </div>
      )
    }

    return (
      <div>
        <Grid>
           <GridCell span="12">
            <Button dense onClick={this.handleBack}>Back</Button>
          </GridCell>
          <GridCell span="10">
            <Typography use="headline6">{packageName}</Typography>
          </GridCell>
          <GridCell span="2">
            
          </GridCell>
        </Grid>
        {displayComponent}
      </div>
    );
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(CoursePackageDetails);


// WEBPACK FOOTER //
// ./src/views/purchases/CoursePackageDetails.jsx